<template>
  <div class="game-over">
    <h2>Game Over</h2>
    <div>Try again</div>
    <button v-on:click="makeInitialMap">
      <img src="../refresh-arrow.svg">
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["makeInitialMap"])
  }
};
</script>

<style scoped>
h2 {
  margin-top: 100px;
}
button {
  margin-top: 10px;
  border: none;
  background: #00afff;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;

}
img {
  width: 18px;
}
.game-over {
  color: #fff;
  position: absolute;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  animation: appear 0.5s;
}

@keyframes appear {
  from {
    transform: scale(0.6);
    opacity: 0;
  }

  to {
    transform: none;
    opacity: 1;
  }
}
</style>
